<template>
<div id="Tictactoe" class="routes_components tic_tac_toe_view">
  <div class="row score_row">
    <div class="col score_div score_div_right">
      <span id="player_won" v-b-popover.bottom="'Won'">You <span class="score">{{player}}</span></span>
    </div>
    <div class="col text-center score_div">
      <span id="tictactoe_tie" v-b-popover.bottom="'Tie'">Tie <span class="score">{{tie}}</span></span>
    </div>
    <div class="col score_div score_div_left">
      <span id="bot_won" v-b-popover.bottom="'Won'" >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Bot <span class="score">{{computer}}</span></span> <br>
    </div>
  </div>
  <div class="center_div_tictactoe">
    <div class="tictactoe_wrap">
  <div class="row row_1">
    <div class="row_div">
      <a href="#" class="anchor_tag " @click='player_move("data_1")'>
        <div class="btn_col_1 btn_col" id="data_1" value="data_1" :class="tie_class ? 'tie_class' : winner_class ? 'winner_class' : ''">
          <transition name="fade_btn">
            <span class="player_icon" v-if="this.data.data_1 == ''">X</span>
            <span :class="player_icon" v-if="this.data.data_1 == 'player'">{{player_icon}}</span>
            <span :class="computer_icon" v-if="this.data.data_1 == 'computer'">{{computer_icon}}</span>
          </transition>
        </div>
      </a>
      <a href="#" class="anchor_tag " @click='player_move("data_2")'>
        <div class=" btn_col_2 btn_col" id="data_2" value="data_2" :class="tie_class ? 'tie_class' : winner_class ? 'winner_class' : ''">
          <transition name="fade_btn">
            <span class="player_icon" v-if="this.data.data_2 == ''">X</span>
            <span :class="player_icon" v-if="this.data.data_2 == 'player'">{{player_icon}}</span>
            <span :class="computer_icon" v-if="this.data.data_2 == 'computer'">{{computer_icon}}</span>
          </transition>
        </div>
      </a>
      <a href="#" class="anchor_tag " @click='player_move("data_3")'>
        <div class="btn_col_3 btn_col" id="data_3" value="data_3" :class="tie_class ? 'tie_class' : winner_class ? 'winner_class' : ''">
          <transition name="fade_btn">
            <span class="player_icon" v-if="this.data.data_3 == ''">X</span>
            <span :class="player_icon" v-if="this.data.data_3 == 'player'">{{player_icon}}</span>
            <span :class="computer_icon" v-if="this.data.data_3 == 'computer'">{{computer_icon}}</span>
          </transition>
        </div>
      </a>
    </div>
  </div>
  <div class="row row_2">
    <div class="row_div">
      <a href="#" class="anchor_tag " @click='player_move("data_4")'>
        <div class="btn_col_4 btn_col" id="data_4" value="data_4" :class="tie_class ? 'tie_class' : winner_class ? 'winner_class' : ''">
          <transition name="fade_btn">
            <span class="player_icon" v-if="this.data.data_4 == ''">X</span>
            <span :class="player_icon" v-if="this.data.data_4 == 'player'">{{player_icon}}</span>
            <span :class="computer_icon" v-if="this.data.data_4 == 'computer'">{{computer_icon}}</span>
          </transition>
        </div>
      </a>
      <a href="#" class="anchor_tag " @click='player_move("data_5")'>
        <div class="btn_col_5 btn_col" id="data_5" value="data_5" :class="tie_class ? 'tie_class' : winner_class ? 'winner_class' : ''">
          <transition name="fade_btn">
            <span class="player_icon" v-if="this.data.data_5 == ''">X</span>
            <span :class="player_icon" v-if="this.data.data_5 == 'player'">{{player_icon}}</span>
            <span :class="computer_icon" v-if="this.data.data_5 == 'computer'">{{computer_icon}}</span>
          </transition>
        </div>
      </a>
      <a href="#" class="anchor_tag " @click='player_move("data_6")'>
        <div class="btn_col_6 btn_col" id="data_6" value="data_6" :class="tie_class ? 'tie_class' : winner_class ? 'winner_class' : ''">
          <transition name="fade_btn">
            <span class="player_icon" v-if="this.data.data_6 == ''">X</span>
            <span :class="player_icon" v-if="this.data.data_6 == 'player'">{{player_icon}}</span>
            <span :class="computer_icon" v-if="this.data.data_6 == 'computer'">{{computer_icon}}</span>
          </transition>
        </div>
      </a>
    </div>
  </div>
  <div class="row row_3">
    <div class="row_div">
      <a href="#" class="anchor_tag" @click='player_move("data_7")'>
        <div class="btn_col_7 btn_col" id="data_7" value="data_7" :class="tie_class ? 'tie_class' : winner_class ? 'winner_class' : ''">
          <transition name="fade_btn">
            <span class="player_icon" v-if="this.data.data_7 == ''">X</span>
            <span :class="player_icon" v-if="this.data.data_7 == 'player'">{{player_icon}}</span>
            <span :class="computer_icon" v-if="this.data.data_7 == 'computer'">{{computer_icon}}</span>
          </transition>
        </div>
      </a>
      <a href="#" class="anchor_tag" @click='player_move("data_8")'>
        <div class="btn_col_8 btn_col" id="data_8" value="data_8" :class="tie_class ? 'tie_class' : winner_class ? 'winner_class' : ''">
          <transition name="fade_btn">
            <span class="player_icon" v-if="this.data.data_8 == ''">X</span>
            <span :class="player_icon" v-if="this.data.data_8 == 'player'">{{player_icon}}</span>
            <span :class="computer_icon" v-if="this.data.data_8 == 'computer'">{{computer_icon}}</span>
          </transition>
        </div>
      </a>
      <a href="#" class="anchor_tag" @click='player_move("data_9")'>
        <div class="btn_col_9 btn_col" id="data_9" value="data_9" :class="tie_class ? 'tie_class' : winner_class ? 'winner_class' : '' ">
          <transition name="fade_btn">
            <span class="player_icon" v-if="this.data.data_9 == ''">X</span>
            <span :class="player_icon" v-if="this.data.data_9 == 'player'">{{player_icon}}</span>
            <span :class="computer_icon" v-if="this.data.data_9 == 'computer'">{{computer_icon}}</span>
          </transition>
        </div>
      </a>
    </div>
  </div>
  </div>
</div>
  <div class="row options_row">
    <div class="col p-0 m-0 tic_buttons_1">
          <div class="switch-field switch_one">
            <input type="radio" id="radio-three" name="switch-two" v-model="mode" value="easy" :disabled="disable_mode" />
            <label for="radio-three">Easy</label>
            <input type="radio" id="radio-four" name="switch-two" v-model="mode" value="hard" :disabled="disable_mode" />
            <label for="radio-four">Hard</label>
          </div>
        </div>
        <div class="col text-center p-0 m-0 tic_buttons_2">
          <div class="switch-field switch_two">
            <input type="radio" id="radio-one" name="switch-one" v-model="current_move" value="player" :disabled="disable_radio" />
            <label for="radio-one">You</label>
            <input type="radio" id="radio-two" name="switch-one" v-model="current_move" value="computer" :disabled="disable_radio" />
            <label for="radio-two">Bot</label>
          </div>
        </div>
        <div class="col p-0 m-0 tic_buttons_3">
          <button type="button" class="reset_button" name="button" @click="reset()">Reset</button>
        </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Tictactoe',
  data() {
    return {
      move_count: 0,
      player: 0,
      tie: 0,
      computer: 0,
      tie_class: false,
      winner_class:false,
      disable_radio: false,
      disable_mode: false,
      mode: 'easy',
      current_move: 'player',
      player_icon: 'X',
      computer_icon: 'O',
      data: {
        data_1: '',
        data_2: '',
        data_3: '',
        data_4: '',
        data_5: '',
        data_6: '',
        data_7: '',
        data_8: '',
        data_9: '',
      },
      player_winner: [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        []
      ],
      computer_winner: [
        [],
        [],
        [],
        [],
        [],
        [],
        [],
        []
      ],
      random_values: ["data_1", "data_2", "data_3", "data_4", "data_5", "data_6", "data_7", "data_8", "data_9"],
    };
  },
  mounted() {
   this.$root.$emit('bv::disable::popover', 'player_won');
   this.$root.$emit('bv::disable::popover', 'bot_won');
   this.$root.$emit('bv::disable::popover', 'tictactoe_tie');
 },
  beforeRouteLeave (to, from, next) {
    next();
    this.reset();
},
  methods: {
    player_move(player_value) {
      this.move_count++;
      this.disable_radio = true;
      this.disable_mode = true;
      if (this.current_move == "player" && this.data[player_value] == "") {
        this.data[player_value] = this.current_move;
        this.random_values = this.random_values.filter(e => e !== player_value);
        if (player_value == "data_1") {
          this.player_winner[0].push(player_value);
          this.player_winner[3].push(player_value);
          this.player_winner[6].push(player_value);
        }
        if (player_value == "data_2") {
          this.player_winner[0].push(player_value);
          this.player_winner[4].push(player_value);
        }
        if (player_value == "data_3") {
          this.player_winner[0].push(player_value);
          this.player_winner[5].push(player_value);
          this.player_winner[7].push(player_value);
        }
        if (player_value == "data_4") {
          this.player_winner[1].push(player_value);
          this.player_winner[3].push(player_value);
        }
        if (player_value == "data_5") {
          this.player_winner[1].push(player_value);
          this.player_winner[4].push(player_value);
          this.player_winner[6].push(player_value);
          this.player_winner[7].push(player_value);
        }
        if (player_value == "data_6") {
          this.player_winner[1].push(player_value);
          this.player_winner[5].push(player_value);
        }
        if (player_value == "data_7") {
          this.player_winner[2].push(player_value);
          this.player_winner[3].push(player_value);
          this.player_winner[7].push(player_value);
        }
        if (player_value == "data_8") {
          this.player_winner[2].push(player_value);
          this.player_winner[4].push(player_value);
        }
        if (player_value == "data_9") {
          this.player_winner[2].push(player_value);
          this.player_winner[5].push(player_value);
          this.player_winner[6].push(player_value);
        }
        if (
          this.data.data_1 == "player" && this.data.data_2 == "player" && this.data.data_3 == "player" ||
          this.data.data_4 == "player" && this.data.data_5 == "player" && this.data.data_6 == "player" ||
          this.data.data_7 == "player" && this.data.data_8 == "player" && this.data.data_9 == "player" ||
          this.data.data_1 == "player" && this.data.data_4 == "player" && this.data.data_7 == "player" ||
          this.data.data_2 == "player" && this.data.data_5 == "player" && this.data.data_8 == "player" ||
          this.data.data_3 == "player" && this.data.data_6 == "player" && this.data.data_9 == "player" ||
          this.data.data_1 == "player" && this.data.data_5 == "player" && this.data.data_9 == "player" ||
          this.data.data_3 == "player" && this.data.data_5 == "player" && this.data.data_7 == "player") {
          this.player += 1;
          this.current_move = "";
          for (var i = 0; i < 8; i++) {
            if (this.player_winner[i].length == 3) {
              this.setplayer_winner(this.player_winner[i])
            }
          }
          setTimeout(function() {
            this.data.data_1 = '';
            this.data.data_2 = '';
            this.data.data_3 = '';
            this.data.data_4 = '';
            this.data.data_5 = '';
            this.data.data_6 = '';
            this.data.data_7 = '';
            this.data.data_8 = '';
            this.data.data_9 = '';
            this.current_move = "player";
            this.player_winner = [
              [],
              [],
              [],
              [],
              [],
              [],
              [],
              []
            ];
            this.computer_winner = [
              [],
              [],
              [],
              [],
              [],
              [],
              [],
              []
            ];
            this.random_values = ["data_1", "data_2", "data_3", "data_4", "data_5", "data_6", "data_7", "data_8", "data_9"];
          }.bind(this), 2000)
        } else if (this.random_values.length == 0) {
          this.tie += 1;
          this.current_move = "";
          this.tie_addclass();
          setTimeout(function() {
            this.data.data_1 = '';
            this.data.data_2 = '';
            this.data.data_3 = '';
            this.data.data_4 = '';
            this.data.data_5 = '';
            this.data.data_6 = '';
            this.data.data_7 = '';
            this.data.data_8 = '';
            this.data.data_9 = '';
            this.current_move = "player";
            this.player_winner = [
              [],
              [],
              [],
              [],
              [],
              [],
              [],
              []
            ];
            this.computer_winner = [
              [],
              [],
              [],
              [],
              [],
              [],
              [],
              []
            ];
            this.random_values = ["data_1", "data_2", "data_3", "data_4", "data_5", "data_6", "data_7", "data_8", "data_9"];
          }.bind(this), 2000)
        } else {
          this.current_move = "computer";
          this.computer_move();
        }
      } else {
        return null;
      }
    },
    computer_move() {
      this.move_count++;
      this.disable_radio = true;
      this.disable_mode = true;
      var computer_value;
      var random_length = Math.floor((Math.random() * this.random_values.length - 1) + 1);
      setTimeout(function() {
        if (this.current_move == "computer") {
          if (this.mode == 'hard') {
            if (this.data.data_1 == "computer" && this.data.data_2 == "computer" && this.data.data_3 == "") {
              computer_value = "data_3"
            } else if (this.data.data_1 == "computer" && this.data.data_2 == "" && this.data.data_3 == "computer") {
              computer_value = "data_2"
            } else if (this.data.data_1 == "" && this.data.data_2 == "computer" && this.data.data_3 == "computer") {
              computer_value = "data_1"
            } else if (this.data.data_4 == "computer" && this.data.data_5 == "computer" && this.data.data_6 == "") {
              computer_value = "data_6"
            } else if (this.data.data_4 == "computer" && this.data.data_5 == "" && this.data.data_6 == "computer") {
              computer_value = "data_5"
            } else if (this.data.data_4 == "" && this.data.data_5 == "computer" && this.data.data_6 == "computer") {
              computer_value = "data_4"
            } else if (this.data.data_7 == "computer" && this.data.data_8 == "computer" && this.data.data_9 == "") {
              computer_value = "data_9"
            } else if (this.data.data_7 == "computer" && this.data.data_8 == "" && this.data.data_9 == "computer") {
              computer_value = "data_8"
            } else if (this.data.data_7 == "" && this.data.data_8 == "computer" && this.data.data_9 == "computer") {
              computer_value = "data_7"
            } else if (this.data.data_1 == "computer" && this.data.data_4 == "computer" && this.data.data_7 == "") {
              computer_value = "data_7"
            } else if (this.data.data_1 == "computer" && this.data.data_4 == "" && this.data.data_7 == "computer") {
              computer_value = "data_4"
            } else if (this.data.data_1 == "" && this.data.data_4 == "computer" && this.data.data_7 == "computer") {
              computer_value = "data_1"
            } else if (this.data.data_2 == "computer" && this.data.data_5 == "computer" && this.data.data_8 == "") {
              computer_value = "data_8"
            } else if (this.data.data_2 == "computer" && this.data.data_5 == "" && this.data.data_8 == "computer") {
              computer_value = "data_5"
            } else if (this.data.data_2 == "" && this.data.data_5 == "computer" && this.data.data_8 == "computer") {
              computer_value = "data_2"
            } else if (this.data.data_3 == "computer" && this.data.data_6 == "computer" && this.data.data_9 == "") {
              computer_value = "data_9"
            } else if (this.data.data_3 == "computer" && this.data.data_6 == "" && this.data.data_9 == "computer") {
              computer_value = "data_6"
            } else if (this.data.data_3 == "" && this.data.data_6 == "computer" && this.data.data_9 == "computer") {
              computer_value = "data_3"
            } else if (this.data.data_1 == "computer" && this.data.data_5 == "computer" && this.data.data_9 == "") {
              computer_value = "data_9"
            } else if (this.data.data_1 == "computer" && this.data.data_5 == "" && this.data.data_9 == "computer") {
              computer_value = "data_5"
            } else if (this.data.data_1 == "" && this.data.data_5 == "computer" && this.data.data_9 == "computer") {
              computer_value = "data_1"
            } else if (this.data.data_3 == "computer" && this.data.data_5 == "computer" && this.data.data_7 == "") {
              computer_value = "data_7"
            } else if (this.data.data_3 == "computer" && this.data.data_5 == "" && this.data.data_7 == "computer") {
              computer_value = "data_5"
            } else if (this.data.data_3 == "" && this.data.data_5 == "computer" && this.data.data_7 == "computer") {
              computer_value = "data_3"
            } else if (this.data.data_1 == "player" && this.data.data_2 == "player" && this.data.data_3 == "") {
              computer_value = "data_3"
            } else if (this.data.data_1 == "player" && this.data.data_2 == "" && this.data.data_3 == "player") {
              computer_value = "data_2"
            } else if (this.data.data_1 == "" && this.data.data_2 == "player" && this.data.data_3 == "player") {
              computer_value = "data_1"
            } else if (this.data.data_4 == "player" && this.data.data_5 == "player" && this.data.data_6 == "") {
              computer_value = "data_6"
            } else if (this.data.data_4 == "player" && this.data.data_5 == "" && this.data.data_6 == "player") {
              computer_value = "data_5"
            } else if (this.data.data_4 == "" && this.data.data_5 == "player" && this.data.data_6 == "player") {
              computer_value = "data_4"
            } else if (this.data.data_7 == "player" && this.data.data_8 == "player" && this.data.data_9 == "") {
              computer_value = "data_9"
            } else if (this.data.data_7 == "player" && this.data.data_8 == "" && this.data.data_9 == "player") {
              computer_value = "data_8"
            } else if (this.data.data_7 == "" && this.data.data_8 == "player" && this.data.data_9 == "player") {
              computer_value = "data_7"
            } else if (this.data.data_1 == "player" && this.data.data_4 == "player" && this.data.data_7 == "") {
              computer_value = "data_7"
            } else if (this.data.data_1 == "player" && this.data.data_4 == "" && this.data.data_7 == "player") {
              computer_value = "data_4"
            } else if (this.data.data_1 == "" && this.data.data_4 == "player" && this.data.data_7 == "player") {
              computer_value = "data_1"
            } else if (this.data.data_2 == "player" && this.data.data_5 == "player" && this.data.data_8 == "") {
              computer_value = "data_8"
            } else if (this.data.data_2 == "player" && this.data.data_5 == "" && this.data.data_8 == "player") {
              computer_value = "data_5"
            } else if (this.data.data_2 == "" && this.data.data_5 == "player" && this.data.data_8 == "player") {
              computer_value = "data_2"
            } else if (this.data.data_3 == "player" && this.data.data_6 == "player" && this.data.data_9 == "") {
              computer_value = "data_9"
            } else if (this.data.data_3 == "player" && this.data.data_6 == "" && this.data.data_9 == "player") {
              computer_value = "data_6"
            } else if (this.data.data_3 == "" && this.data.data_6 == "player" && this.data.data_9 == "player") {
              computer_value = "data_3"
            } else if (this.data.data_1 == "player" && this.data.data_5 == "player" && this.data.data_9 == "") {
              computer_value = "data_9"
            } else if (this.data.data_1 == "player" && this.data.data_5 == "" && this.data.data_9 == "player") {
              computer_value = "data_5"
            } else if (this.data.data_1 == "" && this.data.data_5 == "player" && this.data.data_9 == "player") {
              computer_value = "data_1"
            } else if (this.data.data_3 == "player" && this.data.data_5 == "player" && this.data.data_7 == "") {
              computer_value = "data_7"
            } else if (this.data.data_3 == "player" && this.data.data_5 == "" && this.data.data_7 == "player") {
              computer_value = "data_5"
            } else if (this.data.data_3 == "" && this.data.data_5 == "player" && this.data.data_7 == "player") {
              computer_value = "data_3"
            } else {
              computer_value = this.random_values[random_length];
            }
          } else {
            computer_value = this.random_values[random_length];
          }
          this.data[computer_value] = this.current_move;
          this.random_values = this.random_values.filter(e => e !== computer_value);
          if (computer_value == "data_1") {
            this.computer_winner[0].push(computer_value);
            this.computer_winner[3].push(computer_value);
            this.computer_winner[6].push(computer_value);
          }
          if (computer_value == "data_2") {
            this.computer_winner[0].push(computer_value);
            this.computer_winner[4].push(computer_value);
          }
          if (computer_value == "data_3") {
            this.computer_winner[0].push(computer_value);
            this.computer_winner[5].push(computer_value);
            this.computer_winner[7].push(computer_value);
          }
          if (computer_value == "data_4") {
            this.computer_winner[1].push(computer_value);
            this.computer_winner[3].push(computer_value);
          }
          if (computer_value == "data_5") {
            this.computer_winner[1].push(computer_value);
            this.computer_winner[4].push(computer_value);
            this.computer_winner[6].push(computer_value);
            this.computer_winner[7].push(computer_value);
          }
          if (computer_value == "data_6") {
            this.computer_winner[1].push(computer_value);
            this.computer_winner[5].push(computer_value);
          }
          if (computer_value == "data_7") {
            this.computer_winner[2].push(computer_value);
            this.computer_winner[3].push(computer_value);
            this.computer_winner[7].push(computer_value);
          }
          if (computer_value == "data_8") {
            this.computer_winner[2].push(computer_value);
            this.computer_winner[4].push(computer_value);
          }
          if (computer_value == "data_9") {
            this.computer_winner[2].push(computer_value);
            this.computer_winner[5].push(computer_value);
            this.computer_winner[6].push(computer_value);
          }
          if (
            this.data.data_1 == "computer" && this.data.data_2 == "computer" && this.data.data_3 == "computer" ||
            this.data.data_4 == "computer" && this.data.data_5 == "computer" && this.data.data_6 == "computer" ||
            this.data.data_7 == "computer" && this.data.data_8 == "computer" && this.data.data_9 == "computer" ||
            this.data.data_1 == "computer" && this.data.data_4 == "computer" && this.data.data_7 == "computer" ||
            this.data.data_2 == "computer" && this.data.data_5 == "computer" && this.data.data_8 == "computer" ||
            this.data.data_3 == "computer" && this.data.data_6 == "computer" && this.data.data_9 == "computer" ||
            this.data.data_1 == "computer" && this.data.data_5 == "computer" && this.data.data_9 == "computer" ||
            this.data.data_3 == "computer" && this.data.data_5 == "computer" && this.data.data_7 == "computer") {
            this.computer += 1;
            this.current_move = '';
            for (var i = 0; i < 8; i++) {
              if (this.computer_winner[i].length == 3) {
                this.setcomputer_winner(this.computer_winner[i])
              }
            }
            setTimeout(function() {
              this.data.data_1 = '';
              this.data.data_2 = '';
              this.data.data_3 = '';
              this.data.data_4 = '';
              this.data.data_5 = '';
              this.data.data_6 = '';
              this.data.data_7 = '';
              this.data.data_8 = '';
              this.data.data_9 = '';
              this.current_move = 'computer';
              this.player_winner = [
                [],
                [],
                [],
                [],
                [],
                [],
                [],
                []
              ];
              this.computer_winner = [
                [],
                [],
                [],
                [],
                [],
                [],
                [],
                []
              ];
              this.random_values = ["data_1", "data_2", "data_3", "data_4", "data_5", "data_6", "data_7", "data_8", "data_9"];
              this.computer_move();
            }.bind(this), 2000)
          } else if (this.random_values.length == 0) {
            this.tie += 1;
            this.current_move = '';
            this.tie_addclass();
            setTimeout(function() {
              this.data.data_1 = '';
              this.data.data_2 = '';
              this.data.data_3 = '';
              this.data.data_4 = '';
              this.data.data_5 = '';
              this.data.data_6 = '';
              this.data.data_7 = '';
              this.data.data_8 = '';
              this.data.data_9 = '';
              this.current_move = 'computer';
              this.player_winner = [
                [],
                [],
                [],
                [],
                [],
                [],
                [],
                []
              ];
              this.computer_winner = [
                [],
                [],
                [],
                [],
                [],
                [],
                [],
                []
              ];
              this.random_values = ["data_1", "data_2", "data_3", "data_4", "data_5", "data_6", "data_7", "data_8", "data_9"];
              this.computer_move();
            }.bind(this), 2000)
          } else {
            this.current_move = "player";
          }
        } else {
          return null;
        }
      }.bind(this), 700);
    },
    setplayer_winner(player_winners) {
      var i;
      var doc_ids = ["data_1", "data_2", "data_3", "data_4", "data_5", "data_6", "data_7", "data_8", "data_9"];
      for (i = 0; i < 3; i++) {
        doc_ids = doc_ids.filter(e => e !== player_winners[i]);
      }
      for (i = 0; i < 6; i++) {
        this.data[doc_ids[i]] = "";
      }
      this.$root.$emit('bv::enable::popover', 'player_won');
this.$root.$emit('bv::show::popover', 'player_won');
setTimeout(function() {
  this.$root.$emit('bv::hide::popover', 'player_won');
  this.$root.$emit('bv::disable::popover', 'player_won');
}.bind(this), 3000);
      setTimeout(function() {
        this.winner_class = true;
      }.bind(this), 400);
      setTimeout(function() {
        this.winner_class = false;
      }.bind(this), 700);
      setTimeout(function() {
        this.winner_class = true;
      }.bind(this), 1000);
      setTimeout(function() {
        this.winner_class = false;
      }.bind(this), 1300);
      setTimeout(function() {
        this.winner_class = true;
      }.bind(this), 1600);
      setTimeout(function() {
        this.winner_class = false;
      }.bind(this), 1900);
    },
    setcomputer_winner(computer_winners) {
      var i;
      var doc_ids = ["data_1", "data_2", "data_3", "data_4", "data_5", "data_6", "data_7", "data_8", "data_9"];
      for (i = 0; i < 3; i++) {
        doc_ids = doc_ids.filter(e => e !== computer_winners[i]);
      }
      for (i = 0; i < 6; i++) {
        this.data[doc_ids[i]] = "";
      }
      this.$root.$emit('bv::enable::popover', 'bot_won');
this.$root.$emit('bv::show::popover', 'bot_won');
setTimeout(function() {
  this.$root.$emit('bv::hide::popover', 'bot_won');
  this.$root.$emit('bv::disable::popover', 'bot_won');
}.bind(this), 3000);
      setTimeout(function() {
        this.winner_class = true;
      }.bind(this), 400);
      setTimeout(function() {
        this.winner_class = false;
      }.bind(this), 700);
      setTimeout(function() {
        this.winner_class = true;
      }.bind(this), 1000);
      setTimeout(function() {
        this.winner_class = false;
      }.bind(this), 1300);
      setTimeout(function() {
        this.winner_class = true;
      }.bind(this), 1600);
      setTimeout(function() {
        this.winner_class = false;
      }.bind(this), 1900);
    },
    tie_addclass() {
      this.$root.$emit('bv::enable::popover', 'tictactoe_tie');
this.$root.$emit('bv::show::popover', 'tictactoe_tie');
setTimeout(function() {
  this.$root.$emit('bv::hide::popover', 'tictactoe_tie');
  this.$root.$emit('bv::disable::popover', 'tictactoe_tie');
}.bind(this), 3000);
      setTimeout(function() {
        this.tie_class = true;
      }.bind(this), 400);
      setTimeout(function() {
        this.tie_class = false;
      }.bind(this), 700);
      setTimeout(function() {
        this.tie_class = true;
      }.bind(this), 1000);
      setTimeout(function() {
        this.tie_class = false;
      }.bind(this), 1300);
      setTimeout(function() {
        this.tie_class = true;
      }.bind(this), 1600);
      setTimeout(function() {
        this.tie_class = false;
      }.bind(this), 1900);
    },
    reset() {
      if (this.current_move == "player") {
        this.move_count = 0;
        this.random_values = ["data_1", "data_2", "data_3", "data_4", "data_5", "data_6", "data_7", "data_8", "data_9"];
        this.player = 0;
        this.tie = 0;
        this.computer = 0;
        this.player_winner = [
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          []
        ];
        this.computer_winner = [
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          []
        ];
        this.data.data_1 = '';
        this.data.data_2 = '';
        this.data.data_3 = '';
        this.data.data_4 = '';
        this.data.data_5 = '';
        this.data.data_6 = '';
        this.data.data_7 = '';
        this.data.data_8 = '';
        this.data.data_9 = '';
        this.disable_radio = false;
        this.disable_mode = false;
      }
    },
  },
  watch: {
    current_move: function(new_value) {
      if (this.move_count == 0 && new_value == "computer") {
        this.computer_move();
      }
    },
  },
}
</script>

<style>
</style>
